import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "visually-hidden" }
const _hoisted_2 = {
  key: 1,
  class: "text-h5"
}

import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeaderLogo',
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const store = useStore()
const emit = __emit

const logoUrl = computed(() => store.state.customization?.logoUrl || '')
const hotelName = computed(() => store.state.descriptiveInfo.hotelName)
const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (logoUrl.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_v_img, {
          src: logoUrl.value,
          alt: _unref(t)('App#Logo#Alt Main logo'),
          class: "cursor-pointer",
          "max-height": _ctx.$vuetify.display.mobile ? '60' : '100',
          "max-width": _ctx.$vuetify.display.mobile ? '180' : '300',
          "min-height": _ctx.$vuetify.display.mobile ? '30' : '50',
          "min-width": _ctx.$vuetify.display.mobile ? '60' : '100',
          "aspect-ratio": "3/2",
          contain: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
        }, null, 8, ["src", "alt", "max-height", "max-width", "min-height", "min-width"]),
        _createElementVNode("h1", _hoisted_1, _toDisplayString(hotelName.value), 1)
      ], 64))
    : (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(hotelName.value), 1))
}
}

})